import { atom, selector } from 'recoil';

export const feeMasterDocName = atom({
    key: 'feeMasterDocName',
    default: [],
});